<template>
  <div class="order-detail">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">订单详情</div>
      <i class="iconfont"></i>
    </div>
    <!-- 代付款 -->
    <div
      v-if="
        orderInfo.status == '待付款' &&
          (orderCountdown.m > 0 || orderCountdown.s > 0)
      "
    >
      <div class="order-status">
        <div class="status-left">
          <i class="iconfont">&#xe601;</i>
          <div>
            <div class="status-title">待付款</div>
            <div class="status-txt">
              剩
              <span>{{ orderCountdown.m }}分{{ orderCountdown.s }}秒</span>
              自动关闭订单，请尽快支付
            </div>
          </div>
        </div>
        <div class="pay-btn">
          <div class="logistics-btn primary" @click="toPay">立即支付</div>
        </div>
      </div>
    </div>
    <!-- 其他状态 -->
    <div v-else>
      <div class="order-status-header-content">
        <div class="status">
          <i class="iconfont">&#xe601;</i>
          <span class="label">{{ orderInfo.status }}</span>
          <div
            class="wait-buyer-confirm-goods"
            @click="goOrderTrack"
            v-if="
              allOrderStatus.WAIT_BUYER_CONFIRM_GOODS ==
                orderInfo.status_code && isMobile
            "
          >
            <span class="">物流信息</span>
            <span class="iconfont-ot-website">&#xe6ed;</span>
          </div>
        </div>
        <div
          class="description"
          v-if="
            allOrderStatus.WAIT_BUYER_CONFIRM_GOODS === orderInfo.status_code
          "
        >
          <span>（订单将在10天后自动确认收货）</span>
        </div>
        <div
          class="wait-buyer-confirm-goods is-desktop"
          @click="goOrderTrack"
          v-if="
            allOrderStatus.WAIT_BUYER_CONFIRM_GOODS === orderInfo.status_code &&
              !isMobile
          "
        >
          <span class="">物流信息</span>
          <span class="iconfont-ot-website">&#xe6ed;</span>
        </div>
      </div>
    </div>
    <div class="order-base-info">
      <!-- 订单信息 -->
      <div class="order-item">
        <div class="order-title">订单信息</div>
        <div class="txt">
          订单编号：{{ orderInfo.id || $route.query.id }}
          <span
            class="iconfont-ot-website"
            @click="copyText(orderInfo.id || $route.query.id)"
            >&#xe606;</span
          >
        </div>
        <div class="txt">下单时间： {{ orderInfo.time }}</div>
        <div class="txt">
          支付方式：{{ orderInfo.payWay }}
          {{
            orderInfo.installmentNumber > 0
              ? `（￥${orderInfo.everyCost}*${orderInfo.installmentNumber}期，${
                  orderInfo.serviceCharge > 0
                    ? "含手续费￥" + orderInfo.serviceCharge + "/期"
                    : "免手续费"
                }）`
              : null
          }}
        </div>
      </div>
      <!-- 配送信息 -->
      <div class="order-item" v-if="orderInfo.address">
        <div class="order-title">配送信息</div>
        <div class="txt">
          收货人： {{ getText("name", orderInfo.address[0].username) }}
          <span class="iconfont-ot-website icon-hide" @click="hideInfo">{{
            showInfo ? `&#xe6f7;` : `&#xe6f8;`
          }}</span>
        </div>
        <div class="txt">
          手机：{{ getText("mobile", orderInfo.address[0].mobile) }}
        </div>
        <div class="txt">
          地址：{{ orderInfo.address[0].province }}
          {{ orderInfo.address[0].city }}
          {{ orderInfo.address[0].county }}
          {{ getText("", orderInfo.address[0].detail) }}
        </div>
        <div class="txt" v-if="orderInfo.address[0].postcode">
          邮编：{{ orderInfo.address[0].postcode }}
        </div>
      </div>
    </div>
    <!-- 配送清单 -->
    <div class="order-list">
      <div class="order-title">配送清单</div>
      <div class="order-content">
        <div class="content-title">商品</div>
        <div class="content">
          <div
            class="goods-items"
            v-for="(item, index) in orderInfo.goods"
            :key="index"
          >
            <div class="goods-items-content">
              <div class="item-img">
                <div @click="goDetail(item)">
                  <img :src="item.cover" alt class="goods-pic" />
                  <span v-if="item.status" class="order-status-babel">{{ item.status }}</span>
                </div>
              </div>
              <div class="goods-right">
                <div class="goods-info">
                  <div @click="goDetail(item)" class="goods-name">{{ item.name }}</div>
                  <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                    <div v-for="(label, index) in item.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
                      {{ label }}
                    </div>
                  </template>
                  <div class="goods-size">
                    <div style="margin-right: 30px">
                      颜色：{{ item.color.name }}
                    </div>
                    <div>尺码：{{ item.size }}</div>
                  </div>
                  <ProductLabel :product-label="item.product_label" />
                  <p class="markdown-tip is-desktop" v-if="item.is_mark_down">
                    <span class="iconfont-ot-website">&#xe60f;</span>
                    <span>折扣商品不可与其他活动同时享受折扣</span>
                  </p>
                </div>
                <div class="goods-others">
                  <div class="goods-price">
                    <div class="num">x{{ item.quantity }}</div>
                    <div class="price">
                      <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
                      <p
                        class="item-original_price"
                        v-if="isShowOriginalPrice(item)"
                      >
                       ￥{{ (item.original_price || 0) | filterPrice }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="payment-detail is-desktop"
                    v-if="orderInfo.goods.length > 1"
                  >
                    <!-- TODO: 联调替换取值 -->
                    <div class="point-text">
                      实付金额：<span>￥{{ item.row_amount }}</span>
                    </div>
                    <div class="point-text">
                      使用积分：<span>{{ item.pointsDeducted || 0 }}积分</span>
                    </div>
                  </div>
                </div>
                <div class="goods-action" v-if="!isMobile">
                  <OTBaseButton
                    v-if="item.rma_id"
                    text="售后详情"
                    size="small"
                    @onClick="goAfterSaleDetail(item)"
                  />
                </div>
              </div>
            </div>
            <p class="markdown-tip is-mobile" v-if="item.is_mark_down">
              <span class="iconfont-ot-website">&#xe60f;</span>
              <span>折扣商品不可与其他活动同时享受折扣</span>
            </p>
            <div
              class="payment-detail is-mobile"
              v-if="orderInfo.goods.length > 1"
            >
              <!-- TODO: 联调替换取值 -->
              <div class="point-text">
                实付金额：<span>￥{{ item.row_amount }}</span>
              </div>
              <div class="point-text">
                使用积分：<span>{{ item.pointsDeducted || 0 }}积分</span>
              </div>
            </div>
            <div class="goods-action" v-if="isMobile">
              <OTBaseButton
                v-if="item.rma_id"
                text="售后详情"
                size="small"
                @onClick="goAfterSaleDetail(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单摘要 -->
    <div :class="['order-others', isDiscount ? 'has-discount' : '']">
      <div class="total">
        <div class="tit">商品总额：</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.original_subtotal || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">优惠金额：</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span @click="openDiscountPopup">{{(orderInfo.discount_amount || 0) | filterPrice }}</span>
          <i class="iconfont icon-right-arrow"
            v-if="isDiscount"
            @click="openDiscountPopup"
            >&#xe628;</i>
        </div>
      </div>
      <div class="total">
        <div class="tit">使用积分：</div>
        <div class="num">
          <span class="rmb-symbol op0"></span>
          <span>{{ orderInfo.pointsDeducted || 0 }}积分</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">运费：</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.shipping || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">总计：</div>
        <div class="num">
          <span class="rmb-symbol" style="color: #000">￥</span>
          <span style="color: #000">{{
            (orderInfo.amount || 0) | filterPrice
          }}</span>
        </div>
      </div>
    </div>
    <div class="delivery-date" ref="buttonBoxRef">
      <div
        class="logistics-bottom"
        v-if="orderButtonGroup.length"
        :class="{ sticky: isButtonBoxSticky }"
      >
        <div
          :class="[
            'logistics-btn',
            item.buttonType,
            item.action === 'applyInvoice' ? 'udesk-go-service' : '',
          ]"
          v-for="(item, index) in orderButtonGroup"
          @click="orderAction(item.action)"
          :key="index"
        >
          {{ item.text }}
        </div>
      </div>
    </div>

    <TipDialog
      :visible="afterSalesExpiredTipDialogVisible"
      message="如您对商品售后有疑问，请联系在线客服处理"
      leftButtonText="取消"
      rightButtonText="联系客服"
      subtitle="抱歉，您的订单已过售后申请失效"
      @dialog-cancel="handleCloseTipDialog"
      type="udesk-go-service"
    />

    <TipDialog
      :visible="afterSalesConfirmReceiptTipDialogVisible"
      message="积分将在您确认收货后7个工作日发放"
      leftButtonText="取消"
      rightButtonText="确认收货"
      subtitle="请您确认收货"
      @dialog-cancel="handleCloseTipDialog"
      @dialog-confirm="confirmReceipt"
    />

    <AfterSaleDrawer
      v-if="showDrawer"
      title="退款申请流程"
      :initialData="{ ...tempOrderInfo, order_no: order_no }"
      :visible.sync="showDrawer"
      @submit="handleSubmit"
      @close="handleDrawerClose"
    />
    <!-- 支付扫码弹窗 -->
    <div class="dialog wait-pay" v-if="payStatus == 'wait'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideWaitPayDialog"
            >&#xe61e;</i
          >
        </div>
        <div class="dialog-body">
          <div class="pay-method">
            <template v-if="paymentMethod == 1 || paymentMethod == 3">
              <i class="iconfont ali-pay">&#xe600;</i>
            </template>
            <template v-else>
              <i class="iconfont wx-pay">&#xe62b;</i>
            </template>
            <span class="pay-name">{{
              ["", "支付宝", "微信支付", "支付宝", "微信支付", "微信支付"][
                paymentMethod
              ]
            }}</span>
          </div>
          <div class="pay-amount">
            支付金额：
            <span class="pay-value">
              <span class="rmb-symbol">￥</span> {{ orderInfo.amount }}
            </span>
          </div>
          <div class="pay-hits">
            <div class="pay-countdown">
              距离二维码过期还剩<span class="countdown"
                >{{ countdown.m }}分{{ countdown.s }}秒</span
              >
            </div>
            <div class="pay-msg">过期后请点击刷新重新获取二维码</div>
          </div>
          <div class="pay-code">
            <img :src="payCode" />
            <div v-if="codeMask" class="code-mask" @click="refreshPayCode">
              <span>已失效</span>
            </div>
          </div>
          <div class="pay-method-tips">
            <div class="text">
              打开{{
                ["", "支付宝", "微信", "支付宝", "微信", "微信"][paymentMethod]
              }}扫一扫
            </div>
            <div class="text">扫描上方二维码完成付款</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付结果弹窗 -->
    <div class="dialog pay-unknown" v-if="payStatus == 'unknown'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="closePayUnknown">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="dialog-subtitle">支付结果</div>
          <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
          <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
          <div class="btn-group">
            <button class="btn" @click="closePayUnknown">已完成支付</button>
            <button class="btn" @click="toPay">支付遇到问题，重新支付</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="discountPopupVisible && orderInfo">
      <DiscountPopup
        :visible="discountPopupVisible"
        :initData="orderInfo"
        @close="handleDiscountPopupClose"
      />
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import utilsOrder from "@/utils/order";
import ProductLabel from "@/components/ProductLabel.vue";
import { captureManualError } from "@/sentry/index";
import AfterSaleDrawer from "@/components/afterSale/afterSaleDrawer.vue";
import OTBaseButton from "@/components/baseCom/button.vue";
import TipDialog from "@/components/TipDialog.vue";
import DiscountPopup from "@/components/DiscountPopup.vue";

export default {
  components: { AfterSaleDrawer, OTBaseButton, ProductLabel, TipDialog, DiscountPopup },

  data() {
    return {
      allOrderStatus: utilsOrder.OrderStatus,
      orderInfo: {},
      tempOrderInfo: {},
      order_no: "",
      showInfo: false,
      orderButtonGroup: [],
      waitPayTimer: null,
      orderCountdown: { m: 0, s: 0 },
      showModal: false,
      //
      paymentMethod: "",
      payCode: "",
      oderPayTimer: null,
      countdown: { m: 0, s: 0 },
      codeMask: false,
      payStatus: "",
      wsInstance: null,
      //
      formLabelWidth: "25%",
      isPaySuccess: false,
      // 添加轮询定时器引用
      orderStatusPollingTimer: null,
      refundInfoForm: {
        company: "",
        sid: "",
      },
      showDrawer: false,
      isButtonBoxSticky: true,
      afterSalesExpiredTipDialogVisible: false,
      afterSalesConfirmReceiptTipDialogVisible: false,
      orderStatusTimer: null,
      discountPopupVisible: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getOrderDetail();
      this.order_no = this.$route.query.id;
    } else {
      this.$router.replace({ path: "/myaccount/orders" });
    }
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    getOrderDetail() {
      api[types.ORDER_DETAIL]({ id: this.$route.query.id })
        .then((res) => {
          if (res?.code == 1) {
            let orderInfo = res.data;
            const ramGoods = utils.filterRamGoods(res.data);
            this.orderButtonGroup = utilsOrder.getOrderButtonGroup({
              status_code: res.data.status_code,
              channel: res.data.channel || "",
              isMob: window.innerWidth <= 768,
              is_rma: ramGoods.length > 0 ? 1 : 0
            });
            if (orderInfo.status == "待付款") {
              let timesAgo =
                Date.now() -
                new Date(orderInfo.time.replace(/-/g, "/")).getTime();
              // 待支付订单有效支付时间为15分钟
              if (timesAgo >= 15 * 60 * 1000) {
                console.info("待支付订单已超时");
              } else {
                let ret = Math.floor((15 * 60 * 1000 - timesAgo) / 1000);
                this.waitPayTimer = this.startCountdown(ret, (times, timer) => {
                  if (times > 0) {
                    this.orderCountdown = {
                      m: Math.floor(times / 60),
                      s: times % 60,
                    };
                  } else {
                    timer && clearInterval(timer);
                    if (this.oderPayTimer) {
                      this.$message({ message: "订单支付超时已自动关闭" });
                      this.getOrderDetail();
                    }
                    this.orderCountdown = { m: 0, s: 0 };
                    this.orderInfo.status = ""; // 修改订单状态
                  }
                });
              }
            }
            this.orderInfo = orderInfo;
            return res;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function")
        return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 继续支付：处理支付方式（沿用上次支付方式）
    toPay() {
      if (utils.isWXBrowser()) {
        this.paymentMethod = 5;
      } else if (utils.isMobile()) {
        this.paymentMethod = this.orderInfo.payWay == "支付宝" ? 3 : 4;
      } else {
        this.paymentMethod = this.orderInfo.payWay == "支付宝" ? 1 : 2;
      }
      this.orderPay();
    },
    // 订单支付
    // 订单支付
    orderPay() {
      api[types.ORDER_PAY]({
        orderId: this.orderInfo.id || this.$route.query.id,
        paymentMethod: this.paymentMethod,
      })
        .then((res) => {
          if (res?.code == 1) {
            if (this.paymentMethod == 1 || this.paymentMethod == 2) {
              this.payCode = res.data.url;
              this.codeMask = false;
              // 4分钟倒计时
              this.wsInstance = null;
              let oderPayTimer = this.startCountdown(
                res.data.expire,
                (times, timer) => {
                  if (times > 0) {
                    this.countdown = {
                      m: Math.floor(times / 60),
                      s: times % 60,
                    };
                  } else {
                    timer && clearInterval(timer);
                    this.countdown = { m: 0, s: 0 };
                    this.codeMask = true;
                    this.wsInstance?.close();
                  }
                }
              );
              this.oderPayTimer = oderPayTimer;
              // 查询支付状态
              this.checkOrderStatus(res.data?.id);
              this.showWaitPayDialog();
            } else {
              this.payStatus = "unknown";
              window.location.href = res?.data?.url;
            }
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },
    // 刷新支付二维码
    refreshPayCode() {
      this.orderPay();
    },
    showWaitPayDialog() {
      this.payStatus = "wait";
    },
    hideWaitPayDialog() {
      this.wsInstance?.close();
      this.oderPayTimer && clearInterval(this.oderPayTimer);
      this.payStatus = "";
    },
    closePayUnknown() {
      this.payStatus = "";
      this.getOrderDetail();
    },
    // 查询支付状态
    checkOrderStatus(id) {
      const intervalId = setInterval(() => {
        if (this.payStatus === "success") {
          clearInterval(intervalId);
          return;
        }
        api[types.ORDER_STATUS]({ id })
          .then((res) => {
            if (res.code === 1 && res.data.status === 1) {
              this.$message({ message: "支付成功" });
              this.payStatus = "success";
              this.hideWaitPayDialog();
              this.getOrderDetail();
              this.gaTrack4Purchase();
              intervalId && clearInterval(intervalId);
            }
          })
          .catch((err) => {
            captureManualError(err);
            console.error("查询支付状态失败:", err);
          });
      }, 3000);
      this.orderStatusTimer = intervalId;
    },
    clearOrderPayTimer() {
      this.orderStatusTimer && clearInterval(this.orderStatusTimer);
    },

    orderAction(action) {
      if (action === "pay") {
        this.toPay();
      } else if (action === "applyAfterSales") {
        this.applyAfterSales();
      } else if (action === "confirmReceipt") {
        this.confirmReceipt({ type: "confirmReceipt" });
      } else if (action === "applyInvoice") {
        this.applyInvoice();
      }
    },
    applyAfterSales() {
      const {
        is_rma,
        // time,
        status_code,
      } = this.orderInfo;
      // if (dayjs(time).isBefore(dayjs("2024-02-29 23:59:59"))) {
      //   return null;
      // }
      // 整单不可售后
      if (is_rma === 0) {
        this.afterSalesExpiredTipDialogVisible = true;
        return null;
      }

      const ramGoods = utils.filterRamGoods(this.orderInfo);
      this.tempOrderInfo = { ...this.orderInfo, goods: ramGoods };
      // 已发货的订单申请售后，需要先确认收货
      if (status_code === this.allOrderStatus.WAIT_BUYER_CONFIRM_GOODS) {
        this.afterSalesConfirmReceiptTipDialogVisible = true;
        return;
      } else {
        this.showDrawer = true;
      }
    },
    confirmReceipt(value) {
      const { type = "" } = value || {};
      const order_id = this.orderInfo.order_id || this.$route.query.id;
      api[types.CONFIRM_RECEIPT]({ order_id })
        .then(() => {
          this.$message.success("收货成功");
          this.getOrderDetail();
          if (type !== "confirmReceipt") {
            this.afterSalesConfirmReceiptTipDialogVisible = false;
            this.showDrawer = true;
          }
        })
        .catch(() => {
          // TODO: 错误处理
        });
    },
    applyInvoice() {
      console.log("applyInvoice");
    },
    handleDrawerClose() {
      this.showDrawer = false;
    },
    handleSubmit() {
      this.showDrawer = false;
    },

    // GA埋点
    gaTrack4Purchase() {
      const params = {
        send_to: process.env?.VUE_APP_GA4,
        currency: "CNY",
        transaction_id: this.orderInfo.id || this.$route.query.id,
        shipping: Number(this.orderInfo.shipping),
        value: Number(this.orderInfo.amount),
        items: this.orderInfo.goods.map((o) => ({
          item_id: `${o.goodsId}-${o.color.id}`,
          item_name: o.name,
          price: Number(o.price),
          quantity: Number(o.quantity),
          item_brand: "Onitsuka Tiger",
          item_variant: o.color.name,
          currency: "CNY",
        })),
      };
      if (window.gtag) {
        window.gtag("event", "purchase", params);
      }
    },

    // 启动订单状态轮询
    startOrderStatusPolling() {
      // 清除可能存在的旧轮询
      if (this.orderStatusPollingTimer) {
        clearInterval(this.orderStatusPollingTimer);
      }

      const orderId = this.orderInfo.id || this.$route.query.id;

      // 每5秒查询一次订单状态
      this.orderStatusPollingTimer = setInterval(() => {
        // 检查是否还有倒计时，如果没有则停止轮询
        if (
          (this.orderCountdown.m <= 0 && this.orderCountdown.s <= 0) ||
          this.orderInfo.status_code === "TRADE_CLOSED_BY_TAOBAO"
        ) {
          this.stopOrderStatusPolling();
          return;
        }

        // 查询订单状态
        api[types.ORDER_STATUS]({ id: orderId })
          .then((res) => {
            if (res.code === 1) {
              // 如果订单已支付成功，更新状态并停止轮询
              if (res.data.status === 1) {
                this.isPaySuccess = true;
                this.stopOrderStatusPolling();
                this.getOrderDetail();
              }
            }
          })
          .catch((error) => {
            console.warn("轮询订单状态失败:", error);
          });
      }, 5000);
    },

    // 停止订单状态轮询
    stopOrderStatusPolling() {
      if (this.orderStatusPollingTimer) {
        clearInterval(this.orderStatusPollingTimer);
        this.orderStatusPollingTimer = null;
      }
    },
    handleCloseTipDialog() {
      this.afterSalesExpiredTipDialogVisible = false;
      this.afterSalesConfirmReceiptTipDialogVisible = false;
    },
    goBack() {
      this.$router.push({ path: "/myaccount/orders" });
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return;
      }
      if (Number(item.skc_status) === 0) {
        //skc下架
        return;
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },

    openDiscountPopup() {
      if(this.isDiscount) {
        this.discountPopupVisible = true;
      }
    },
    handleDiscountPopupClose() {
      this.discountPopupVisible = false;
    },
    goAfterSaleDetail(item) {
      this.$router.push({
        name: "afterSaleDetail",
        path: "/myaccount/afterSaleDetail",
        query: {
          rma_id: item.rma_id,
          id: this.orderInfo.id || this.$route.query.id,
        },
      });
    },

    goOrderTrack() {
      this.$router.push({
        name: "orderTrack",
        path: "/myaccount/orderTrack",
        query: {
          orderId: this.orderInfo.id,
          id: this.orderInfo.id || this.$route.query.id,
          logistic_code: this.orderInfo.logistic_code,
        },
      });
    },

    copyText(text) {
      utils.copyText(text);
    },
    hideInfo() {
      this.showInfo = !this.showInfo;
    },
    getText(type, text) {
      if (this.showInfo) {
        return text;
      }
      return utils.formatSensitiveInfo(type, text);
    },
    handleScroll() {
      if (!this.$refs.buttonBoxRef) return;

      const buttonRect = this.$refs.buttonBoxRef.getBoundingClientRect();

      if (buttonRect.top + 60 < window.innerHeight) {
        this.isButtonBoxSticky = false;
      } else {
        this.isButtonBoxSticky = true;
      }
    },
  },

  mounted() {
    if (this.isMobile) {
      document.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    document.removeEventListener("scroll", this.handleScroll);
    this.clearOrderPayTimer();
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    isDiscount() {
      const { detail_discount = {}, original_subtotal_desc = [], discount_amount } = this.orderInfo || {}
      const discountAmount = discount_amount !== "0.00"
      const hasDetailDiscount = Object.values(detail_discount).some(arr => Array.isArray(arr) && arr.length > 0)
      const hasOriginalSubtotalDesc = Array.isArray(original_subtotal_desc) && original_subtotal_desc.length > 0

      return discountAmount && (hasDetailDiscount || hasOriginalSubtotalDesc)
    },
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  text-align: left;

  .dialog {
    width: 0;
    height: 0;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 1010;
      background: url(../../assets/imgs/ui-overlay-shadow.png) repeat scroll 50%
        50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;

      .dialog-header {
        position: relative;
        text-align: left;
      }

      .dialog-body {
        display: flex;
      }
    }

    &.wait-pay {
      .dialog-container {
        width: 470px;
        height: 570px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          align-items: center;

          .pay-method {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 45px;

            .iconfont {
              font-size: 40px;

              &.ali-pay {
                color: rgb(0, 159, 233);
              }

              &.wx-pay {
                color: rgb(79, 163, 42);
              }
            }

            .pay-name {
              font-size: 20px;
              margin-left: 10px;
            }
          }

          .pay-amount {
            font-size: 14px;
            color: #666666;
            margin-top: 20px;

            .pay-value {
              font-size: 25px;
              color: #8b0013;
            }
          }

          .pay-hits {
            height: 40px;
            margin-top: 18px;

            .pay-countdown,
            .pay-msg {
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              text-align: center;

              .countdown {
                color: #8b0013;
              }
            }
          }

          .pay-code {
            margin-top: 10px;
            position: relative;

            img {
              width: 190px;
              height: 190px;
            }

            .code-mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              span {
                color: #fff;
              }
            }
          }

          .pay-method-tips {
            height: 40px;
            margin-top: 10px;

            .text {
              font-size: 14px;
              line-height: 20px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }

    &.pay-unknown {
      .dialog-container {
        width: 472px;
        height: 310px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .dialog-subtitle {
            font-size: 16px;
            color: #333333;
            font-weight: 700;
            margin-top: 40px;
          }

          .txt-line {
            font-size: 14px;
            color: #666666;

            &.mt20 {
              margin-top: 20px;
            }
          }

          .btn-group {
            margin-top: 28px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 20px;
                color: #666666;
                background: #ffffff;
                border: 1px solid #e7e7e7;
              }
            }
          }
        }
      }
    }
  }

  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    .page-title {
      font-size: 13px;
      color: #333333;
      line-height: 40px;
      text-align: center;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
  }

  .order-status {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background: #fbfbfb;

    .status-left {
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 35px;
        color: #7f0019;
        margin-right: 20px;
      }

      .status-title {
        font-size: 16px;
        color: #7f0019;
      }

      .status-txt {
        color: #666;
        font-size: 14px;

        span {
          color: #8b0013;
        }
      }
    }

    .pay-btn {
      // display: flex;
    }

    .logistics-btn {
      display: none;
      cursor: pointer;
    }
  }
  .order-status-header-content {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background: #fbfbfb;
    .status {
      display: flex;
      align-items: center;
      color: #7f0019;

      .iconfont {
        font-size: 35px;
        margin-right: 20px;
      }
      .label {
        font-size: 20px;
      }
    }
    .description {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;
      flex: 1;
    }
    .wait-buyer-confirm-goods {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #666666;
      line-height: 1;

      .logistics {
        text-decoration: underline;
      }
      &.is-mobile {
        display: none;
      }
    }
  }

  .order-base-info {
    display: flex;
    align-items: center;
    flex-direction: row;
    border-bottom: 1px solid #d7d8d8;
  }

  .iconfont-ot-website {
    cursor: pointer;
  }

  .icon-hide {
    margin-left: 10px;
  }

  .order-list {
    padding: 30px 0;
  }

  .order-item,
  .order-list {
    color: #666;
    font-size: 14px;
    padding: 24px 0;
    box-sizing: border-box;

    .order-title {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .txt {
      font-size: 12px;
      line-height: 24px;

      a {
        text-decoration: underline;
      }
    }

    .order-content {
      border: none;

      .content-title {
        display: none;
      }

      .content {
        max-height: 330px;
        overflow-y: auto;

        .goods-items {
          // TODO: 如引用orderItem 组件
          // display: flex;
          // flex-direction: column;
          // gap: 14px;
          // padding-left: 2px;

          // ::v-deep .goods-items-content {
          //   display: flex;
          //   box-sizing: border-box;
          //   margin-bottom: 20px;
          //   padding: 0 30px;
          //   .goods-others {
          //     flex-direction: column;
          //     align-items: normal;
          //   }
          // }

          & + .goods-items {
            margin-top: 24px;
          }

          .markdown-tip {
            display: flex;
            align-items: center;
            color: #212322;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-top: 8px;

            .iconfont-ot-website {
              margin-right: 2px;
              cursor: pointer;
            }

            &.is-desktop {
              display: none;
            }

            &.is-mobile {
              display: block;
            }
          }
        }

        .goods-items-content {
          display: flex;
          box-sizing: border-box;
          padding: 0;

          .item-img {
            width: 86px;
            height: 86px;
            border-radius: 1px;
            border: 1px solid #dfdfdf;
            margin-right: 8px;
            flex-shrink: 0;
            box-sizing: border-box;
            padding: 2px;
            position: relative;

            .goods-pic {
              // width: 78px;
              width: 100%;
              height: auto;
            }

            .order-status-babel {
              width: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.5);
              color: #fff;
              font-size: 12px;
              text-align: center;
              line-height: 18px;
            }
          }

          .goods-right {
            display: flex;
            flex-direction: column;
          }

          .goods-info {
            display: flex;
            flex-direction: column;
            width: 100%;

            .goods-size {
              display: flex;
              color: #999999;
              font-size: 12px;
            }

            .goods-name {
              font-size: 14px;
              color: #333;
            }

            .item-tag {
              font-size: 10px;
              border: 1px solid #212322;
              padding: 0px 5px;
              margin: 4px 0;
              line-height: 18px;
              color: #212322;
              width: fit-content;
            }
          }

          .goods-others {
            display: flex;
            flex-direction: column;
            font-size: 12px;
            color: #000;
            width: 100%;

            .goods-price {
              display: flex;
              flex-direction: row-reverse;
              justify-content: space-between;
              align-items: flex-end;

              .price {
                display: flex;
                align-items: center;
                gap: 8px;
              }
            }

            .item-original_price {
              font-weight: 400;
              color: #999;
              text-decoration: line-through;
            }
          }

          .goods-action {
            width: 20%;
            margin-left: 10px;
            flex: none;
            .ot-base-button {
              float: right;
              font-size: 12px;
              color: #666666;
            }
          }
        }
      }
    }
    .payment-detail {
      display: flex;
      flex-direction: row;
      align-content: center;

      .point-text {
        padding: 0px 20px;
        color: #999;
        span {
          color: #333;
        }
        &:first-child {
          position: relative;
          padding-left: 0px;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 12px;
            background-color: #bcbdbf;
          }
        }
      }

      &.is-mobile {
        display: none;
      }
    }
  }

  .order-item {
    flex: 1;
    // border-bottom: 1px solid #d7d8d8;
  }

  // .service-charge {
  //   text-decoration: line-through;
  // }

  .order-others {
    padding-bottom: 30px;

    &.has-discount {
      .num {
        padding-right: 16px;
        position: relative;

        .icon-right-arrow {
          position: absolute;
          right: 0;
          top: 54%;
          transform: translateY(-50%);
          cursor: pointer;
        }
      }
    }

    .total {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      // width: 100%;

      & + .total {
        margin-top: 8px;
      }
    }

    .tit {
      font-size: 14px;
      line-height: 20px;
      color: #000;
      font-weight: 400;
      min-width: 70px;
    }

    .num {
      font-family: Matter;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #999999;
    }

    .op0 {
      opacity: 0;
      margin-left: 4px;
    }
  }

  .logistics-bottom {
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .logistics-btn {
    padding: 10px 77px;
    font-size: 14px;
    text-align: center;
    justify-content: flex-end;
    cursor: pointer;
  }

  .primary {
    background: #7f0019;
    color: #fff;
    border: 1px solid #7f0019;
  }

  .default {
    color: #000000;
    border: 1px solid #000000;
  }
}

@media only screen and (min-width: 768px) {
  .order-detail {
    .page-header {
      display: none;
    }

    .order-status {
      .status-left {
        .status-title {
          font-size: 20px;
        }
      }

      .logistics-btn {
        display: block;
      }
    }

    .order-item,
    .order-list {
      color: #666;
      font-size: 14px;
      padding: 30px 0;
      box-sizing: border-box;

      .order-title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .txt {
        font-size: 14px;
        line-height: 24px;
      }

      & ::v-deep .el-form {
        .el-form-item {
          .el-form-item__content {
            .el-input,
            .el-select {
              width: 200px;
            }
          }
        }
      }

      .save-refund {
        margin-left: 100px;
      }

      .order-content {
        border: 1px solid #d2d2d2;

        .content-title {
          height: 40px;
          color: #333;
          font-size: 14px;
          line-height: 40px;
          border-bottom: 1px solid #d2d2d2;
          margin-bottom: 20px;
          padding-left: 30px;
          display: block;
        }

        .content {
          max-height: 330px;
          overflow-y: auto;

          .goods-items {
            .markdown-tip {
              display: flex;
              align-items: center;
              color: #212322;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 6px;

              .iconfont-ot-website {
                margin-right: 2px;
              }

              &.is-desktop {
                display: block;
              }

              &.is-mobile {
                display: none;
              }
            }
          }

          .goods-items-content {
            display: flex;
            box-sizing: border-box;
            margin-bottom: 20px;
            padding: 0 30px;

            .item-img {
              width: 70px;
              height: 70px;
              border-radius: 1px;
              border: 1px solid #dfdfdf;
              margin-right: 20px;
              flex-shrink: 0;
              box-sizing: border-box;
              padding: 2px;

              .goods-pic {
                width: 64px;
                height: 64px;
              }
            }

            .goods-right {
              display: flex;
              flex-direction: row;
              flex-grow: 1;

              .goods-info {
                display: flex;
                flex-direction: column;
                width: 54%;

                .goods-size {
                  display: flex;
                  color: #999999;
                  font-size: 14px;
                }

                .goods-name {
                  font-size: 14px;
                  color: #333;
                }
              }

              .goods-others {
                width: 40%;
                align-self: flex-start;
                margin-top: 0;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }

    .order-others {
      .total {
        .num {
          font-size: 14px;
          line-height: 28px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .order-detail {
    .dialog.pay-unknown {
      .dialog-container {
        width: 285px;
        height: 225px;

        .dialog-body {
          .dialog-subtitle {
            margin-top: 8px;
          }

          .txt-line {
            font-size: 12px;
          }

          .btn-group {
            margin-top: 20px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }

    .bread-crumbs {
      display: none;
    }

    .page-header {
      display: block;
    }

    .order-base-info {
      flex-direction: column;
      border-bottom: none;

      .order-item {
        width: 100%;
        border-bottom: 1px solid #d7d8d8;
      }
    }
    .order-content {
      .payment-detail {
        display: flex;
        flex-direction: row;
        padding: 8px 0px;
        justify-content: space-between;
        align-content: center;
        background: #f8f8f8;
        margin-top: 16px;

        .point-text {
          color: #999;
          flex: 1;
          padding: 0;
          text-align: center;
          span {
            color: #333;
          }
          &:first-child {
            position: relative;
            padding: 0;
            &::after {
              content: "";
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 1px;
              height: 12px;
              background-color: #bcbdbf;
            }
          }
        }
        &.is-desktop {
          display: none;
        }
        &.is-mobile {
          display: flex;
        }
      }
    }

    .icon-hide {
      float: right;
    }

    .logistics-bottom {
      justify-content: flex-end;
      padding-top: 12px;
      gap: 10px;
      position: relative;

      &.sticky {
        position: fixed;
        bottom: 0;
        left: 0;

        width: 100%;
        background: #fff;
        padding: 12px 10px;
        z-index: 999; // 不能超过 1000 ，左侧菜单栏是1000
        box-sizing: border-box;
      }

      &::after {
        content: "";
        position: absolute;
        width: calc(100% + 20px);
        top: 0;
        left: -10px;
        box-sizing: border-box;
        overflow: hidden;
        border-top: 1px solid rgba(211, 211, 213, 1);
      }

      .logistics-btn {
        padding: 10px 18px;
        font-size: 14px;
        text-align: center;
        justify-content: flex-end;
        cursor: pointer;
      }
    }
    .order-status-header-content {
      flex-direction: column;
      gap: 8px;

      .status {
        position: relative;
        .iconfont {
          margin-right: 16px;
        }
        .label {
          font-size: 16px;
        }
      }
      .description {
        font-size: 12px;
        color: #666666;
      }
      .wait-buyer-confirm-goods {
        position: absolute;
        right: 0;
        color: #666666;
        line-height: 1;
        &.is-desktop {
          display: none;
        }
        &.is-mobile {
          display: block;
        }
      }
    }

    .goods-action {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
    .order-others {
      .total {
        justify-content: space-between;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .goods-items {
    .markdown-tip {
      display: flex;
      align-items: center;
      color: #212322;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;

      .iconfont-ot-website {
        margin-right: 2px;
      }

      &.is-mobile {
        display: none;
      }
    }
  }
}
</style>
